module.exports = [{"type":"path","from":{"data":"nodeTreeLinks"},"encode":{"update":{"path":{"field":"path"},"stroke":{"value":"#ccc"}}}}]


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/links.json
// module id = 8Pij
// module chunks = 0